import { Col } from 'react-bootstrap';
import { SectionHeadingMed, HeadingDesc } from '../../../Components/Headings';
import { SimpleButton } from '../../../Components/button';
import CallToAction from '../../../Components/callToAction/CallToAction';
import img1 from '../../../assets/images/png/bloodpressure.png';

import './bloodPressureMonitor.css';

function BloodPressureMonitor() {
  return (
    <CallToAction
      leftContent={<LeftContent />}
      rightContent={<RightConten />}
    />
  );
}

function LeftContent() {
  return (
    <Col md={5}>
      <div>
        <img src={img1} alt="bloodpressure" />
      </div>
    </Col>
  );
}

function RightConten() {
  return (
    <Col md={7}>
      <div>
        <SectionHeadingMed
          text="بلڈ پریشر کی نگرانی اب دستیاب ہے!
"
        />
        <HeadingDesc
          text="پہننے کے قابل یا وقف شدہ ہارڈویئر کی ضرورت کو دور کرتے ہوئے، میری صحت کا ہیلتھ ڈیٹا پلیٹ فارم، جو سافٹ ویئر ڈویلپمنٹ کٹ (SDK) کے طور پر دستیاب ہے، آلات، آپریٹنگ سسٹمز اور ویب ایپلی کیشنز کی ایک وسیع رینج کو سپورٹ کرتا ہے اور ایسے آلات کا استعمال کرتے ہوئے بغیر کسی رکاوٹ کی صحت اور تندرستی کی نگرانی کو قابل بناتا ہے جو اختتامی صارفین کو استعمال کرتے ہیں۔ پہلے سے موجود ہیں: اسمارٹ فونز، ٹیبلٹ اور لیپ ٹاپ۔
"
        />
        <HeadingDesc
          text="صرف ڈیوائس کے کیمرہ کو دیکھ کر، صارفین ایک منٹ سے بھی کم وقت میں صحت کی مختلف پیمائشیں نکال سکتے ہیں۔
"
        />
        <SimpleButton
          text="اپنے وائٹلز کو ابھی اسکین کریں۔
"
          bgColor="#72D54A"
        />
      </div>
    </Col>
  );
}

export default BloodPressureMonitor;
